<template lang="pug">
.MainDocOption
  .section
    .columns.is-centered.is-mobile
        .column.mode
          .field.is-grouped.is-grouped-centered
            .box
              b-field(custom-class="is-small" label="将棋盤動作モード")
                .flex
                  template(v-for="e in RunModeInfo.values")
                      b-radio-button(type="is-primary" size="is-small" v-model="sp_run_mode" :native-value="e.key") {{e.name}}
    .columns.is-centered.is-mobile
        .ShogiPlayerContainer
            ShogiPlayer(
            sp_summary="is_summary_off"
            sp_layout="is_horizontal"
            sp_controller="is_controller_on"
            :sp_turn.sync="sp_turn"
            sp_overlay_nav="is_overlay_nav_on"
            sp_run_mode= "view_mode"
            :sp_pi_variant= "sp_pi_variant"
            /*sp_bg_variant= "is_bg_variant_none"*/
            :sp_bg_variant= "sp_bg_variant"
            sp_slider= "is_slider_on"
            :sp_player_info= "sp_player_info"
            :sp_body.sync= "sp_body"
            :sp_run_mode.sync="sp_run_mode"
            :sp_viewpoint.sync="sp_viewpoint"
            :sp_hidden_if_piece_stand_blank="sp_hidden_if_piece_stand_blank"
            @update:edit_mode_snapshot_sfen="            e => trigger_check('edit_mode_snapshot_sfen', e)"
            @update:play_mode_advanced_full_moves_sfen=" e => trigger_check('play_mode_advanced_full_moves_sfen', e)"
            @update:mediator_snapshot_sfen=" e => trigger_check('mediator_snapshot_sfen', e)"
            @update:turn_offset=" e => trigger_check('turn_offset', e)"
            
      )
    .column.is-centered.is-mobile
      .box
        .title.is-5 
          //- b-field(custom-class="is-small flex" label="将棋盤スタイル")
          //-   b-radio-button(size="is-small" v-model="sp_board_style" v-on:input="force_paper_style" native-value="paper") 紙面風
          //-   b-radio-button(size="is-small" v-model="sp_board_style" v-on:input="wood_style" native-value="wood") 木
          b-field(custom-class="is-small flex" label="視点")
            b-radio-button(size="is-small" v-model="sp_viewpoint" native-value="black") 先手
            b-radio-button(size="is-small" v-model="sp_viewpoint" native-value="white") 後手
          //- b-field(custom-class="is-small" label="持駒が空なら駒台を表示しない（詰将棋の場合はこれをONにして後手の持駒を空にする）")
          //-   b-radio-button(size="is-small" v-model="sp_hidden_if_piece_stand_blank" :native-value="false") OFF
          //-   b-radio-button(size="is-small" v-model="sp_hidden_if_piece_stand_blank" :native-value="true") ON
          b-field(custom-class="is-small flex" label="対局者名：先手")
            b-input(size="is-small" v-model.trim="sp_player_info.black.name" type="text")
          b-field(custom-class="is-small flex" label="対局者名：後手")
            b-input(size="is-small" v-model.trim="sp_player_info.white.name" type="text")
          //-   何故か「タグをコピー」ボタンがはみ出るのでclass="control is-expanded"追加
          <label class="control is-expanded">
            <a class="button is-info is-light is-fullwidth" @click="doKIFCopy">
              <b-icon icon="content-copy" ></b-icon>
              <span>局面をコピー</span>
            </a>
          </label>
         
    .column.is-centered.is-mobile
      .box
        .title.is-5
          b-field(custom-class="is-small" label="棋譜または局面を入力")
          b-input(size="is-small" v-model="sp_body" v-on:input="doChange" type="textarea")
          b-field(custom-class="is-small" label="")
          //- <button class="button is-info is-light">棋譜ファイル読込</button>
          <b-upload v-model="file" v-on:input="onFileChange" expanded>
              <a class="button is-info is-light is-fullwidth">
              <b-icon icon="upload"></b-icon>
              </b-icon>
              <span>{{ file.name || "棋譜ファイル読込"}}</span>
              </a>
          </b-upload>
          </b-field>

</template>

<script>
import Vue from 'vue'
import Encoding from 'encoding-japanese'
import { RunModeInfo } from '../node_modules/shogi-player/components/models/run_mode_info.js'
// Buefy
import Buefy from 'buefy'
// import 'buefy/dist/buefy.css'
Vue.use(Buefy)

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// 本体
import ShogiPlayer from 'shogi-player/components/ShogiPlayer.vue'

import axios from 'axios'

function shogi_board (options) {
  let shogi = document.createElement('shogi-board')
  for (let key of Object.keys(options)){
    shogi.setAttribute(key, options[key])
  }
  
  return shogi.outerHTML
}

function copyClipboard(copyText, options){
  copyText(shogi_board(options)).then(function () {
    alert('コピーしました。\nテキストボックスにペーストしてください。')
    console.log(shogi_board(options))
  }, function (e) {
    alert('コピーに失敗しました')
    console.log(e)
  })
}

function set_player_info (str, data){
  let black = str.match(/先手：.*/)
  if (black !== null){
    let blackName = black[0].replace(/先手：/, '')
    if (blackName === ''){
      blackName = '先手'
    }
    data['sp_player_info'].black.name = blackName
  } else {
    let black = str.match(/上手：.*/)
    if (black !== null){
      let blackName = black[0].replace(/上手：/, '')
      if (blackName === ''){
        blackName = '上手'
      }
      data['sp_player_info'].black.name = blackName
    }
  }
  let white = str.match(/後手：.*/)
  if (white !== null){
    let whiteName = white[0].replace(/後手：/, '')
    if (whiteName === ''){
      whiteName = '後手'
    }
    data['sp_player_info'].white.name = whiteName
  } else {
    let white = str.match(/下手：.*/)
    if (white !== null){
      let whiteName = white[0].replace(/下手：/, '')
      if (whiteName === ''){
        whiteName = '下手'
      }
      data['sp_player_info'].white.name = whiteName
    }
  }
}

export default {
  name: 'HelloWorld'.replace(/\r\n/g, '¥n').replace(/(\n|\r)/g, '¥n'),
  components: {
    ShogiPlayer,
  },
  props: {
    kif: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      RunModeInfo,

      sp_run_mode: 'play_mode',
      sp_turn: -1,
      sp_body: this.kif,
      edit_mode_snapshot_sfen: null,
      play_mode_advanced_full_moves_sfen: null,
      mediator_snapshot_sfen: null,
      turn_offset: null,
      file: { name: null },
      sp_board_style: 'paper',
      sp_pi_variant: 'is_pi_variant_b', 
      sp_bg_variant: 'is_bg_variant_none',
      sp_player_info: {black: { name: '先手'}, white: { name: '後手' }},
      sp_viewpoint: 'black',
      sp_hidden_if_piece_stand_blank: false,
    }
  },
  computed: {
    
  },
  methods: {
    kifu_source() {
      console.log(this.sp_body || 'position startpos')
      return this.sp_body || 'position startpos'
    },
    doChange: function () {
      set_player_info(this.sp_body, this.$data)
      this.$data['sp_run_mode'] = 'view_mode'
    },
    force_paper_style() {
      this.$data.sp_bg_variant = 'is_bg_variant_none'
      this.$data.sp_pi_variant = 'is_pi_variant_b' // 紙面風駒
    },
    wood_style() {
      this.$data.sp_bg_variant = 'is_bg_variant_b'
      this.$data.sp_pi_variant = 'is_pi_variant_d' 
    },
    doKIFCopy: function () {
      const copyText = this.$copyText
      const options = {
        black: this.sp_player_info.black.name,
        white: this.sp_player_info.white.name,
        kif: 'position startpos',
        board: this.sp_board_style,
        viewpoint: this.sp_viewpoint
        
      }
      if (this.sp_run_mode === 'edit_mode'){
        options.kif = this.edit_mode_snapshot_sfen
        copyClipboard(copyText, options)
        return 
      } else if (this.sp_run_mode === 'view_mode'){
        if (this.sp_body === ''){
          copyClipboard(copyText, options)
          return 
        } else {
          options.kif = this.sp_body
        }
      } else if (this.sp_run_mode === 'play_mode'){
        if (this.play_mode_advanced_full_moves_sfen !== null){
          options.kif = this.play_mode_advanced_full_moves_sfen.sfen
          console.log(options.kif)
        } else {
          options.kif = this.mediator_snapshot_sfen
          copyClipboard(copyText, options)
          return
        }
      }
      
      const url = 'https://www.shogi-extend.com/api/general/any_source_to.json'
      options.turn = this.turn_offset === null ? this.sp_turn:this.turn_offset
      
      axios.post(url, {
        any_source: options.kif,
        to_format: 'ki2'
      }).then(function (response) {
        const num = response.data.body.match(/まで[0-9]*手/)[0].replace(/[^0-9]/g, '')
        const regexp = new RegExp('((▲|△)[^(▲|△|\n)]{2,6}){'+num+'}', 'g')
        const result = response.data.body.replace(/\n|\r| /g, '').match(regexp)
        if (result !== null){
          options.ki2 = result[0].replace(/まで[0-9]*/, '')
          if (options.kif.indexOf('position sfen') !== 0){
            axios.post(url, {
              any_source: options.kif,
              to_format: 'sfen'
            }).then(function (response) {
              options.kif = response.data.body
              copyClipboard(copyText, options)
            }).catch(error => {
              console.log(error.response)
            })
          } else {
            copyClipboard(copyText, options)
          }
        }
        
      }).catch(error => {
        console.log(error)
      })
    },
    sidebar_toggle() {
      this.sidebar_p = !this.sidebar_p
    },
    trigger_check(key, v) {
      this.$data[key] = v
            
      if (this.trigger_toast_p) {
        this.$buefy.toast.open({
          message: `${key} -> ${JSON.stringify(v)}`,
          queue: false,
        })
      }
    },
    onFileChange: function(event) {
      const file = event
      const data = this.$data
      if (!file) {
        return false
      }
      const reader = new FileReader()
      reader.onload = function(e) {
        const uint8Array = new Uint8Array(e.target.result)
        const str = Encoding.codeToString(Encoding.convert(uint8Array, {
          to: 'UNICODE',
          from: 'AUTO'
        }))
        set_player_info(str, data)
        
        data['sp_body'] = str
        data['sp_run_mode'] = 'view_mode'
      }
      reader.readAsArrayBuffer(file)
    },
  },
}
</script>
<style lang="sass">
// ShogiPlayer のスタイル
$sp_assets_dir: "../node_modules/shogi-player/assets"

// Buefyのスタイルをカスタマイズ
@import 'assets/style.scss'

@import "../node_modules/shogi-player/components/ShogiPlayer.sass"
@import url("https://cdn.jsdelivr.net/npm/bulma@0.8.0/css/bulma.css")
@import url("https://cdn.jsdelivr.net/npm/@mdi/font@5.x/css/materialdesignicons.min.css")
@import url("https://fonts.googleapis.com/css?family=Sawarabi+Mincho")
@import url("https://fonts.googleapis.com/css?family=Sawarabi+Gothic")
@import url("https://fonts.googleapis.com/css2?family=Noto+Serif+JP:wght@500&display=swap")

@media screen and (max-width: 768px)
  .ShogiPlayerGround.is_mobile_vertical_on .ShogiPlayerBody
       flex-direction: row !important
  .ShogiPlayerGround.is_mobile_vertical_on .Membership.is_position_south
      flex-direction: column !important
      align-self: flex-end !important
  .ShogiPlayerGround.is_mobile_vertical_on .Membership.is_position_north
      flex-direction: column-reverse !important
  .ShogiPlayerGround .Membership 
    display: flex !important
    align-items: center !important
  .ShogiPlayerGround.is_mobile_vertical_on .Membership
    width: auto !important
  .ShogiPlayerGround.is_mobile_vertical_on .MembershipLocationPlayerInfo
    line-height: 100% !important
  .ShogiPlayerGround.is_mobile_vertical_on .NavigateBlockis-small
    margin-top: 12px !important
  .ShogiPlayerGround.is_mobile_vertical_on .is_position_south .MembershipStand2
    flex-direction: column !important
  .ShogiPlayerGround.is_mobile_vertical_on .is_position_north .MembershipStand2
    flex-direction: column-reverse !important

.section
  max-width: 700px
  // background-color: cornsilk
  background-color: rgb(238, 238, 238)

.ShogiPlayerHeader
  height: 30px
  font-family: 'Noto Serif JP', serif
  font-weight: bold !important

.ShogiPlayerGround .AspectRatioFixedBlockWrap
  padding: 0px 3px !important
.ShogiPlayerGround .NavigateBlockInside
  width: calc(var(--sp_controller_width_mobile) * 100%)

.ShogiPlayerGround.is_balloon_on .MembershipLocationPlayerInfo
  font-family: 'Noto Serif JP', serif
  padding: 0em
  padding-bottom: 1em
  // background-color: cornsilk !important
  background-color: rgb(238, 238, 238) !important

.ShogiPlayerGround.is_mobile_vertical_on .Membership.is_position_south .PieceCount
  top: 5px !important
  bottom: unset !important
  right: unset !important
  left: var(--sp_piece_count_gap_right) !important

.MembershipLocationPlayerInfoName
    writing-mode: vertical-rl

.flex
    display: flex
.ShogiPlayerContainer 
    --sp_piece_origin_color: rgba(0, 0, 0, 0.1)

.ShogiPlayerGround .ShogiPlayerWidth
   --sp_body_width: 100%

.ShogiPlayerGround .MembershipLocationPlayerInfo
    font-size: 1rem !important
    font-weight: bold !important
// ShogiPlayer は常に横100%まで広がるので外側で大きさを調整する
.ShogiPlayerContainer
  width: 100%
  --sp_board_color: hsla(0,0%,100%,1)
  --sp_stand_piece_h: 25px
  --sp_stand_piece_w: 30px
  --sp_piece_count_font_size: 1rem
  --sp_location_mark_inactive_rate: 1
  --se_ws_color: hsla(100,41.18%,80%,1)
  --se_ws_image: none
  --se_ws_blur: 0
  --se_ws_grayscale: 0
  --se_ws_contrast: 1
  --se_ws_invert: 0
  --se_ws_hue: 0
  --se_ws_saturate: 1
  --se_ws_brightness: 1
  --se_ws_sepia: 0

  // 盤テクスチャ
  --sp_board_image: none
  --sp_board_blur: 0
  --sp_board_grayscale: 0
  --sp_board_contrast: 1
  --sp_board_invert: 0
  --sp_board_opacity: 1
  --sp_board_hue: 0
  --sp_board_saturate: 1
  --sp_board_brightness: 1
  --sp_board_sepia: 0
  --sp_board_blend: normal

  // 盤
  --sp_board_padding: 1.5
  --sp_board_radius: 5
  --sp_board_aspect_ratio: 1.097
  --sp_board_piece_rate: 80%
  --sp_board_piece_position: center

  // 盤グリッド
  --sp_grid_color: hsla(0,0%,0%,0.5)
  --sp_grid_outer_color: hsla(0,0%,0%,0.5)
  --sp_grid_stroke: 1
  --sp_grid_outer_stroke: 0
  --sp_grid_star_size: 10%

  // 駒
  --sp_piece_blur: 0
  --sp_piece_grayscale: 0
  --sp_piece_contrast: 1
  --sp_piece_invert: 0
  --sp_piece_opacity: 1
  --sp_piece_hue: 0
  --sp_piece_saturate: 1
  --sp_piece_brightness: 1
  --sp_piece_sepia: 0
  --sp_piece_blend: normal

  // 駒数
  --sp_piece_count_gap_right: 62%
  --sp_piece_count_gap_bottom: 47%
  --sp_piece_count_font_color: hsla(0,0%,0%,0.75)
  --sp_piece_count_bg_color: hsla(0,0%,100%,0.75)
  --sp_piece_count_padding: 2px

  // 駒台
  --sp_stand_piece_rate: 80%
  --sp_stand_hover_border_color: hsla(0,0%,0%,0.2)
  --sp_stand_bg_color: hsla(0,0%,0%,0)

  // 駒箱
  --sp_piece_box_piece_w: 38px
  --sp_piece_box_piece_h: 46px
  --sp_piece_box_piece_rate: 90%
  --sp_piece_box_color: hsla(0,0%,0%,0.2)

  // 影
  --sp_shadow_offset: 2
  --sp_shadow_blur: 3
  --sp_shadow_color: hsla(0,0%,0%,0.4)

  // 成り不成り選択
  --sp_promote_select_modal_bg_color: hsla(0,0%,0%,0.85)
  --sp_promote_select_modal_hover_color: hsla(0,0%,100%,0.5)

  // 駒を操作中の移動元スタイル
  --sp_lifted_origin_bg_color_desktop: hsla(0,0%,0%,0.1)
  --sp_lifted_origin_opacity_desktop: 0
  --sp_lifted_origin_opacity_touch: 1
  --sp_lifted_origin_bg_color_touch: #{change_color($primary, $alpha: 0.3)}

  // 駒台横配置のときの盤の上下の隙間
  --sp_common_gap: 12px

  // 将棋盤全体の外側の横幅(コンテナ幅)
  --se_frame_width: 80vmin

  // コントローラー
  --sp_controller_width: 0.5
  --sp_controller_width_mobile: 0.8

  // Transform 背景
  --se_tf0_perspective: 200px
  --se_tf0_translate_x: 0px
  --se_tf0_translate_y: 0px
  --se_tf0_translate_z: 0px
  --se_tf0_rotate_x: 0.03turn
  --se_tf0_rotate_y: 0turn
  --se_tf0_rotate_z: 0turn
  --se_tf0_scale: 1

  // Transform 盤
  --se_tf1_perspective: 200px
  --se_tf1_translate_x: 0px
  --se_tf1_translate_y: -55px
  --se_tf1_translate_z: 0px
  --se_tf1_rotate_x: 0.015turn
  --se_tf1_rotate_y: 0turn
  --se_tf1_rotate_z: 0turn
  --se_tf1_scale: 1

  // Transform 駒
  --se_tf2_perspective: 200px
  --se_tf2_translate_x: 0px
  --se_tf2_translate_y: 0px
  --se_tf2_translate_z: 0px
  --se_tf2_rotate_x: 0turn
  --se_tf2_rotate_y: 0turn
  --se_tf2_rotate_z: 0turn
  --se_tf2_scale: 1

  --sp_invisible_dimension: 9
  --sp_turn_slider_block_margin_top: 0.75rem
  // 駒成るときのz-index
  --sp_promote_select_modal_z: 30
</style>